
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild, inject,ChangeDetectorRef, QueryList, ViewChildren} from '@angular/core';
import {MatAutocompleteSelectedEvent, MatAutocompleteModule, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {Observable, of} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {MatIconModule} from '@angular/material/icon';
import {NgFor, AsyncPipe} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { FlightService } from 'src/app/services/flight.service';
import { Router,ActivatedRoute } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { UserService } from 'src/app/services/user.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import {AirManagementService}  from 'src/app/services/air-management.service'
import {SettingsService} from 'src/app/services/settings.service';
import { InsuranceService } from 'src/app/services/insurance.service';
import { BusService } from 'src/app/services/bus.service';

@Component({
  selector: 'app-bus',
  templateUrl: './bus.component.html',
  styleUrls: ['./bus.component.css']
})
export class BusComponent {
  @Output() myOutput:EventEmitter<string>= new EventEmitter();  
  outputMessage:string="close";
generatePnr:boolean=false
  departure:any='Hyderabad'
  arrivel:any='Bangalore'
  departureTime:any
  arrivelTime:any
  directFlight:boolean=false
  prefAirline:any=''
  separatorKeysCodes: number[] = [ENTER, COMMA];
  separatorKeysCodesTo: number[] = [ENTER, COMMA];
   minData=new Date()
  fruitCtrl = new FormControl('DEL  Delhi,India - Indira Gandhi International Airport');
  filteredFruits!: Observable<string[]>;
  from: any={
    "id": '',
    "cityName": "Hyderabad",
    "cityLabel": "Hyderabad, Telangana",
    "countryCode": "IN"
}
  // allFruits:any = [];
  allFruits:any=["BOM  Mumbai,India - Chhatrapati Shivaji International Airport","GOI  Goa,India - Dabolim Airport","PNQ  Pune,India - Pune Airport","DEL  Delhi,India - Indira Gandhi International Airport","BLR  Bangalore,India - Kempegowda International Airport","CCU  Kolkata,India - Netaji Subhash Chandra Bose International Airport","HYD  Hyderabad,India - Rajiv Gandhi International Airport","MAA  Madras,India - Chennai International Airport","RAJ  Rajkot,India - Rajkot Airport"]
  whereTo:any=["BOM  Mumbai,India - Chhatrapati Shivaji International Airport","GOI  Goa,India - Dabolim Airport","PNQ  Pune,India - Pune Airport","DEL  Delhi,India - Indira Gandhi International Airport","BLR  Bangalore,India - Kempegowda International Airport","CCU  Kolkata,India - Netaji Subhash Chandra Bose International Airport","HYD  Hyderabad,India - Rajiv Gandhi International Airport","MAA  Madras,India - Chennai International Airport","RAJ  Rajkot,India - Rajkot Airport"]

  max:any
  
  // whereTo:any=[];
  ToCtrl = new FormControl('BOM  Mumbai,India - Chhatrapati Shivaji International Airport');
  filteredTo!: Observable<string[]>;
  wherecity: any={
    "id": '',
    "cityName": "Bangalore",
    "cityLabel": "Bangalore, Karnataka",
    "countryCode": "IN"
}
  @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;
  @ViewChild('airportToInput') ToInput!: ElementRef<HTMLInputElement>;
  @ViewChild('pickers') datePicker!: ElementRef<HTMLInputElement>;

  announcer = inject(LiveAnnouncer);
   travelType:any='AD'
  searchFg!:FormGroup

  showOneWay:boolean=false
  showReturn:boolean=false
  showMulti:boolean=false
  currentNumber: number = 1;
  ccurrentNumber: number = 0;
  icurrentNumber: number = 0;
  selectedItem: string = 'Economy';
  selectedPerson:string ='Adult'
  adult:any;
  child:any;
  Infants:any;
  searchData:any={
    any:"any"
  }
  userName:any
tokenData:any={
  userType:'',
  username:'',
  userUuid:'',
  name:'',
}

constructor(private SettingsService:SettingsService,private AirManagementService:AirManagementService,private renderer: Renderer2,private data:DataService,private FlightService:FlightService,private router:ActivatedRoute ,private route:Router,private fb : FormBuilder, private cdr: ChangeDetectorRef,   private toastMsgService : ToastmsgService,private userService : UserService,
  private userInfoService : UserInfoService,private InsuranceService:InsuranceService,private BusService:BusService){
    this.max =(new Date()).toISOString().slice(0, 10);

  this.tokenData.userType=userInfoService.getUserType();
  this.tokenData.userType=this.tokenData.userType.toUpperCase()

  this.tokenData.username=userInfoService.getUsername();
  this.tokenData.userUuid=this.userInfoService.getUserUuid()


      this.tokenData.name=this.userInfoService.getUserDisplayname();
      
    
  
  if(this.tokenData.userType==='CORPORATE'||this.tokenData.userType==='AGENT'){
    this.userName={
      name:this.tokenData.name,
      userUid:this.tokenData.userUuid,
      username:this.tokenData.username

    }
  }
  // this.getUsersList()
  
  this.data.portMessage.subscribe((message:any) => this.searchData = message)
  this.showOneWay=true
  this.showReturn=true
  if(this.searchData!="default message"){

    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchData.from,[Validators.required]],
      "toAirport" : [this.searchData.to,[Validators.required]],
      "requestedDate":[ new Date(this.searchData.tripStartDate)],
      "requestedClass":[''],
      "paxCount":[this.searchData?.paxCount],
        "adultCount":[this.searchData?.adultCount],
        "childCount":[this.searchData?.childCount],
        "infantCount":[this.searchData?.infantCount],
      "returnDate":[new Date(this.searchData.tripEndDate)],
      "menu":['nivabupa'],
      "geography":[this.searchData?.geography],
      "tripType":[this.searchData?.tripType],
      "source":[this.searchData?.source]
    });
  
    if(this.searchFg?.value?.requestedDate){
      this.departureTime=this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
    }
    this.totalPassengers=this.searchFg.value.paxCount
  
  }else{
  
 
  this.dataFields()


 
}



  this.getFlightList()

  // 
  

  
}


selected(event: any): void {

    
  this.from=event

  this.fromAirportError=false
//  console.log(event.option.viewValue)
  // this.fruitInput.nativeElement.value = event.option.viewValue;
  // this.fruitCtrl.setValue(null);
  this.departure=event.cityName
  this.cdr.detectChanges(); // Force re-render

// console.log(event.option.viewValue.split(` `)[1]?.trim()?.split(',')[1])

}
selectedCityObject ='Hyderabad, Telangana'

selectedToCityObject="Bangalore, Karnataka"
  
selectedTo(event: any): void {
  this.wherecity=event
  this.toAirportError=false

  // this.ToInput.nativeElement.value = event.option.viewValue;
  // this.ToCtrl.setValue(null);
  this.arrivel=event.cityName
  this.cdr.detectChanges(); // Force re-render

}

setToInputStaticValue() {
  // Example: Set static value to the input element
    // this.ToInput.nativeElement.value="BOM  Mumbai,India - Chhatrapati Shivaji International Airport"
  

  // this.fruitInput.nativeElement.value="DEL  Delhi,India - Indira Gandhi International Airport"
  
}
DisplayName:any
ngOnInit(): void {
  let DisplayName:any
this.router.queryParams.subscribe(params => {
  let data:any
  data=this.objectToArray(params)
 
  for(let i=0 ;i <data.length; i++){
  
    DisplayName +=data[i];
  }

    });
    
  
  }
    objectToArray(obj: Record<string, string>): string[] {
      return Object.values(obj);
    }
selectItem(item: string) {
  this.selectedItem = item;
}
selectPerson(item: string) {
  this.selectedPerson = item;
}

totalPassengers: number = 1; // Initial total passengers






// Increment Adult



increment() {
  if (this.currentNumber+this.ccurrentNumber < 9) {
    this.currentNumber++;
    this.totalPassengers++;
    this.adult = this.currentNumber + " Adult";
  }

  this.createArray(this.currentNumber)
}

// Decrement Adult (At least 1 Adult must remain)
decrement() {
  if (this.currentNumber > 1) {
    this.currentNumber--;
    this.totalPassengers--;
    this.adult = this.currentNumber + " Adult";

    // Ensure infants do not exceed adults or max limit
    if (this.icurrentNumber > this.currentNumber || this.icurrentNumber > 4) {
      this.icurrentNumber = Math.min(this.currentNumber, 4);
      this.Infants = this.icurrentNumber + " Infants";
    }
  }
  this.createArray(this.currentNumber)

}

// Increment Children
cIncrement() {
  if (this.currentNumber+this.ccurrentNumber < 9) {
    this.ccurrentNumber++;
    this.totalPassengers++;
    this.child = this.ccurrentNumber + " Child";
  }
}

// Decrement Children
cDecrement() {
  if (this.ccurrentNumber > 0) {
    this.ccurrentNumber--;
    this.totalPassengers--;
    this.child = this.ccurrentNumber + " Child";
  }
}

// Increment Infants (Max 4 Infants, Cannot be more than Adults)
iIncrement() {
  if ( this.icurrentNumber < this.currentNumber && this.icurrentNumber < 4) {
    this.icurrentNumber++;
    this.totalPassengers++;
    this.Infants = this.icurrentNumber + " Infants";
  }
}

// Decrement Infants
iDecrement() {
  if (this.icurrentNumber > 0) {
    this.icurrentNumber--;
    this.totalPassengers--;
    this.Infants = this.icurrentNumber + " Infants";
  }
}

  selectedDetail:boolean=false
  SelectDetail(){
    this.showMultiSearch=false

    this.selectedDetail=true

  }
  closeDetail(){

    this.selectedDetail=false

  }
  showMultiCityFlight(){
        this.showOneWay=false
        this.showReturn=false
        this.showMulti=true
  }
  showOneWayFlight(){
      this.dataFields()
      this.showMulti=false
      this.showReturn=false
      this.showOneWay=true
  }
  showReturnFlight(){
      this.dataReturnFields()
      this.showMulti=false
      this.showReturn=true
      this.showOneWay=false
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.from.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.fruitCtrl.setValue(null);
  }
  addTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our fruit
    if (value) {
      this.wherecity.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.ToCtrl.setValue(null);
  }
  addM(event: MatChipInputEvent,item:any): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.from.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    item=null;
  }
  addMTo(event: MatChipInputEvent,item:any): void {
    const value = (event.value || '').trim();
    // Add our fruit
    if (value) {
      this.wherecity.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.ToCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.from.indexOf(fruit);

    if (index >= 0) {
      this.from.splice(index, 1);

      this.announcer.announce(`Removed ${fruit}`);
    }
  }




 

uuids:any=[]
  searchClick(){
    let date:any=new Date().getDate();

    // console.log(date)
    let uu:any
    // console.log(uu)

    this.uuids.push(this.generateUUIDv4())
    // console.log(this.uuids)

   
  }
  generateUUIDv4(): string {
    let date:any=new Date().getDate();
    let time:any=new Date().getTime();
    let uuidDate:any=date+time;
    // console.log(date+"t"+time)
    return uuidDate+'-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
//   searchFlight(){
//     //this.route.navigate(["/app/Flightlist"]);}
//  window.location.href="/app/Flightlist"
//   }

  dataFields(){
    const originalDate = new Date();
    const newDate = new Date(originalDate.setDate(originalDate.getDate() + 3));

    // const originalTimestamp =newDate;
    // const datePipe = new DatePipe('en-IN');

    // const newTimestamp = datePipe.transform(originalTimestamp, 'yyyy-MM-ddTHH:00:00.000Z');


    this.arrivelTime=''
    this.searchFg=this.fb.group({
      "fromAirport" :  ['',[Validators.required]],
      "toAirport" : [,[Validators.required]],
      "requestedDate":[newDate],
      "requestedClass":[''],
      "paxCount":[0],
      "adultCount":[0],
      "childCount":[0],
      "infantCount":[0],
      "returnDate":[],
      "menu":['nivabupa'],
      "geography":[""],
      "tripType":[""],
      "source":['nivabupa']
    });
if(this.searchFg?.value?.requestedDate){
    this.departureTime=this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
  }
  
  // console.log(this.searchFg?.value?.requestedDate)

  }
  showSearch:boolean=false
  getFlightList(){
   this.showSearch=true
    this.BusService
    .cityList('D')
    .subscribe({
      next : (res:any) => {
           this.showSearch=false

        this.allFruits=[]
          this.whereTo=[]
       
        if(res) {
         let data:any=res
         this.list=data||[]
         if(this.searchData!="default message"){

          this.selectedCityObject = this.searchData?.from?.cityLabel
  
          this.selectedToCityObject=this.searchData?.to?.cityLabel
          this.from=this.searchData?.from
          this.wherecity=this.searchData?.to}else{
            this.wherecity= this.list?.filter((item:any)=>item.cityLabel==="Bangalore, Karnataka")[0]||{
              "id": '',
              "cityName": "Bangalore",
              "cityLabel": "Bangalore, Karnataka",
              "countryCode": "IN"
          }
          this.from= this.list?.filter((item:any)=>item.cityLabel==="Hyderabad, Telangana")[0]||{
            "id": '',
              "cityName": "Hyderabad",
              "cityLabel": "Hyderabad, Telangana",
              "countryCode": "IN"
        }

          }
        } else {    
        
         
        } 
      },error : (err) => {
        this.showSearch=false

        if(this.searchData!="default message"){

        this.selectedCityObject = this.searchData?.from?.cityLabel

        this.selectedToCityObject=this.searchData?.to?.cityLabel
        this.from=this.searchData?.from
        this.wherecity=this.searchData?.to}
        
        // "tripStartDate" : this.SettingsService.formatyyyy_MM_ddDate(this.searchFg.value.requestedDate),
      }
    }
  )
  }

  dateFormate(date:any){
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-IN');
    date = datePipe.transform(parsedDate, 'd MMM yyyy EEEE');
    // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

  }
  convertToISOStringFormat(dateString:any) {
    // Remove the ' 00:00' part and then add 'Z' at the end
    const isoDateString = dateString.replace('00.000 00:00', '00.000Z');
    return isoDateString;
  }
  areDatesEqual(date1: Date, date2: Date): boolean {
    // Compare year, month, and day to check if the dates are equal
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
  }
  onChangeDate(){
  //  this.searchFg.value.returnDate=this.datePlus(this.searchFg.value.requestedDate)
   // if(this.searchFg.value.menu==='return'){
    if(this.searchFg.value.requestedDate){
      let date:any=new Date();
      if (this.areDatesEqual(this.searchFg.value.requestedDate, date)) {
        // Your code for the condition when dates are the same
        this.searchFg.value.requestedDate=new Date()
      } else {
        // Your code for the condition when dates are not the same
      }
    }
     
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg.value.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg.value.toAirport,[Validators.required]],
      "requestedDate":[ this.searchFg.value.requestedDate],
      "requestedClass":[ this.searchFg.value.requestedClass],
      "paxCount":[this.searchFg.value.paxCount],
      "adultCount":[this.searchFg.value.adultCount],
      "childCount":[this.searchFg.value.childCount],
      "infantCount":[this.searchFg.value.infantCount],
      "returnDate":[this.searchFg.value.requestedDate],
      "menu":[],
      "geography":[this.searchFg?.value?.geography],
      "tripType":[this.searchFg?.value?.tripType],
      "source":[this.searchFg?.value?.source]
      
    });
    // this.date1Plus()
  }
  onMultiDate(element:any,item:any){
    if(element){

      element.departureTime=this.dateFormate(element?.requestedDate)?.split(' ')
     
    }


  }
  onOneWayDate(){
    if(this.searchFg?.value?.requestedDate){
      this.departureTime=this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
    }
   
    if(this.searchFg.value.requestedDate){
      let date:any=new Date();
      if (this.areDatesEqual(this.searchFg.value.requestedDate, date)){
        // Your code for the condition when dates are the same
        this.searchFg.value.requestedDate=new Date()
      } else {
        // Your code for the condition when dates are not the same
      }
    }
      
    console.log('12w')
    if (this.searchFg.get('returnDate')?.value) {
          console.log('12F')

      const returnDate = new Date(this.searchFg.get('returnDate')?.value);
      const requestedDate = new Date(this.searchFg.get('requestedDate')?.value);
    
      if ( requestedDate > returnDate) {
        console.log('12dF')

        const newReturnDate = this.datePlus(requestedDate);
        this.searchFg.get('returnDate')?.setValue(newReturnDate);
          this.arrivelTime=this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
        
        
      }
    }
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg?.value?.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg?.value?.toAirport,[Validators.required]],
      "requestedDate":[ this.searchFg?.value?.requestedDate],
      "requestedClass":[ this.searchFg?.value?.requestedClass],
      "paxCount":[this.searchFg?.value?.paxCount],
      "adultCount":[this.searchFg?.value?.adultCount],
      "childCount":[this.searchFg?.value?.childCount],
      "infantCount":[this.searchFg?.value?.infantCount],
      "returnDate":[this.searchFg?.value?.returnDate],
      "menu":[this.searchFg?.value?.menu],
      "geography":[this.searchFg?.value?.geography],
      "tripType":[this.searchFg?.value?.tripType],
      "source":[this.searchFg?.value?.source]
    });

    
  }

  onRChangeDate(){
    this.showReturn=true
    this.showOneWay=true

    if(this.searchFg?.value?.returnDate){
      let date:any=new Date();
      if (this.areDatesEqual(this.searchFg.value.returnDate, date)) {
        // Your code for the condition when dates are the same
        this.searchFg.value.returnDate=new Date()
      } else {
        // Your code for the condition when dates are not the same
      }
  
    
     }
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg?.value?.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg?.value?.toAirport,[Validators.required]],
      "requestedDate":[ this.searchFg?.value?.requestedDate],
      "requestedClass":[ this.searchFg?.value?.requestedClass],
      "paxCount":[this.searchFg?.value?.paxCount],
      "adultCount":[this.searchFg?.value?.adultCount],
      "childCount":[this.searchFg?.value?.childCount],
      "infantCount":[this.searchFg?.value?.infantCount],
      "returnDate":[this.searchFg?.value?.returnDate],
      "menu":["return"],
      "geography":[this.searchFg?.value?.geography],
      "tripType":[this.searchFg?.value?.tripType],
      "source":[this.searchFg?.value?.source]
    });
    if(this.searchFg?.value?.returnDate){
      this.arrivelTime=this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
    }
  }
  dataReturnFields(){

  
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg?.value?.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg?.value?.toAirport,[Validators.required]],
      "requestedDate":[this.searchFg?.value?.requestedDate],
      "requestedClass":[this.searchFg?.value?.requestedClass],
      "paxCount":[0],
      "adultCount":[0],
      "childCount":[0],
      "infantCount":[0],
      "returnDate":[ this.searchFg.value.requestedDate],
      "menu":['return'],
    });
    // this.date1Plus()
    if(this.searchFg?.value?.returnDate){
      this.arrivelTime=this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
    }
  }
  
  fromAirportError:boolean=false
  toAirportError:boolean=false
  bookingType:any='C'
  searchFlight() {
    
    const isEmpty = (value: any) => value === null || value === undefined || value === '';

    const missingFields: string[] = [];
    
    // if (isEmpty(this.searchFg.value.source)) {
    //   missingFields.push('Source');
    // }
    // this.searchFg.value.toAirport= this.wherecity?.split(` `)[0].trim()
    // this.searchFg.value.fromAirport=this.from?.split(` `)[0].trim()
   
    




   
    if (missingFields.length > 0) {
      const fieldList = missingFields.join(', ');
      this.toastMsgService.setMsg({
        msg: `Please select the compulsory field(s): ${fieldList}`,
        msgTitle: 'Warning',
        msgType: 'W'
      });
    }
   else{
      let data:any

      // "tripStartDate" : this.SettingsService.formatyyyy_MM_ddDate(this.searchFg.value.requestedDate),


      data ={
          "from" : this.from,
          "to":this.wherecity,
          "tripStartDate" : this.SettingsService.formatyyyy_MM_ddDate(this.searchFg.value.requestedDate),
         
          
        }
  

  this.uuids=this.generateUUIDv4()
  data.requestId=this.uuids
  data.uuid=this.uuids
  // data.travelType=this.travelType
  // data.directFlight=this.directFlight
  // data.prefAirline=this.prefAirline
  // data.pointerEvents=false
  // data.userBookingContext=this.bookingType
  // data.countryTo=this.domInt.to
  // data.countryFrom=this.domInt.from
  this.data.deliverMsg(data)
  this.myOutput.emit(this.outputMessage);
  this.route.navigate(["/app/buslist"]);



    
    
    // console.log(data)
   
  }

   
  }

  date1Plus(item:any)
{
  const originalDate = new Date(item);
  const newDate = new Date(originalDate.setDate(originalDate.getDate() + 1));
  return newDate
} 
datePlus(item:any)
{
  const originalDate = new Date(item);
  const newDate = new Date(originalDate.setDate(originalDate.getDate()));
  return newDate
} 



showPnrRetrieval:boolean=false





isActive(route: string): boolean {
  return this.route.isActive(route, true);
}
showArrivel:boolean=false








convertTimeZone(input:any){
  console.log()
  const inputDateTime = input;
  const datePipe = new DatePipe('en-IN');

  let formattedDateTime:any = datePipe.transform(inputDateTime, 'yyyy-MM-ddTHH:mm:ss.SSSZ');
  // console.log(formattedDateTime)

  return formattedDateTime;
}



showMultiSearch:boolean=false
onMultiSearchClick(){
  this.selectedDetail=false

  this.showMultiSearch=true
}
onHideMulti(){
  this.showMultiSearch=false

}




suggestions: any[] = [];
filteredUser: any[] = [];;

searchList(event: AutoCompleteCompleteEvent) {
  let filtered: any[] = [];
    let query = event.query;
console.log(event.originalEvent)
    for (let i = 0; i < (this.suggestions as any[]).length; i++) {
        let user = (this.suggestions as any[])[i];
        if (user.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
            filtered.push(user);
        }
    }

    this.filteredUser = filtered;
}
getUsersList(){
  let userType:any
      this.userService.getUserList('')
      .subscribe({
        next : (res:any) => {
          if(res) {
           // console.log(res)
          let  data:any;
          data=res["result"]
          this.suggestions=data
          // for (let i = 0; i < data.length; i++) {
            
          //   this.whereTo.push(data[i]?.name);

          // }
   
        }else{

        }},error : (err) => {
    
          console.error("Error in fetching data");
        }
      }
    )
    
  }
  GetChildData()
{
  this.generatePnr=false
}






dobArray:any=[{dob:''}]
createArray(num: any) {
  this.dobArray=[]
for(let i=0 ;i<num;i++){

  this.dobArray.push({dob:''})
}
  
  
}
tripTypeList:any=[]
geographyList:any=[]

sourceChange(){
  this.InsuranceService.SearchTripType()
        .subscribe({
          next: (res) => {
            let data:any=res?.body
          if(data){
            let item:any=[]
           let  itemGeography:any=[]
            item=data?.items
            itemGeography=data?.items

            item=item.filter((itm:any)=>itm.key==='TRIP_TYPE')
            itemGeography=itemGeography.filter((itm:any)=>itm.key==='geography')

            if(itemGeography!=0){
              this.geographyList=itemGeography[0]?.values
            }   
if(item!=0){
  this.tripTypeList=item[0]?.values
}
          }
  
            //this.router.navigate(["/app/flight"]);
            // this.toastMsgService.setMsg({ msg: "Sorry, there are no matching results ", msgTitle: "Warning", msgType: "W" });
  
          }
        }
        )
}


openAutocomplete(): void {
  
  this.showArrivel=true
  let whereTo=["BOM  Mumbai,India - Chhatrapati Shivaji International Airport","GOI  Goa,India - Dabolim Airport","PNQ  Pune,India - Pune Airport","DEL  Delhi,India - Indira Gandhi International Airport","BLR  Bangalore,India - Kempegowda International Airport","CCU  Kolkata,India - Netaji Subhash Chandra Bose International Airport","HYD  Hyderabad,India - Rajiv Gandhi International Airport","MAA  Madras,India - Chennai International Airport","RAJ  Rajkot,India - Rajkot Airport"]

  // Check if mat-autocomplete is defined
  this.filteredTo = this.ToCtrl.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    startWith(null),
    map((airports: any | null) => (airports ? this._filterTo(airports) : whereTo.slice())),
  );

    this.ToCtrl.setValue(null);
    this.arrivel=null
    // this.renderer.selectRootElement(this.ToInput.nativeElement).focus();

    // this.ToCtrl.setValue(this.ToInput.nativeElement.value);

  



}

private _filterTo(value: string): string[] {
  // Split the input value by comma and take the first part
  const filterValue = value.split(',')[0].toLowerCase().trim();

  // Use the filter method to create a new array containing only the matching fruits
  return this.whereTo.filter((fruit: any) => {
    // Split each fruit by comma and take the first part

    let whereTo:any 

    if(filterValue.includes('goa')){

      whereTo=fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[1]+fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[0]
      }else{
          if(filterValue.split('').length>3){
            whereTo = fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[1];
    
          }else{
            whereTo = fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[0];
    
          }
        }



    const whereTo1 = fruit.split(',')[1].toLowerCase().trim();

    // Check if the lowercase fruit content includes the lowercase filterValue
    // console.log(whereTo?.includes(filterValue))
    return whereTo?.includes(filterValue) 
  } );
}

openDAutocomplete(){
  let allFruits=["BOM  Mumbai,India - Chhatrapati Shivaji International Airport","GOI  Goa,India - Dabolim Airport","PNQ  Pune,India - Pune Airport","DEL  Delhi,India - Indira Gandhi International Airport","BLR  Bangalore,India - Kempegowda International Airport","CCU  Kolkata,India - Netaji Subhash Chandra Bose International Airport","HYD  Hyderabad,India - Rajiv Gandhi International Airport","MAA  Madras,India - Chennai International Airport","RAJ  Rajkot,India - Rajkot Airport"]

  this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
    debounceTime(300), // Adjust the debounce time as needed
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    startWith(null),
    map((airport: any | null) => (airport ? this._filter(airport) : allFruits.slice())),
  );
  
  
  // Check if mat-autocomplete is defined

    this.fruitCtrl.setValue(null);
    this.departure=null
    // this.renderer.selectRootElement(this.fruitInput.nativeElement).focus();

}
private _filter(value: string): string[] {
  // Split the input value by comma and take the first part
  const filterValue = value.split(',')[0].toLowerCase().trim();
  // Use the filter method to create a new array containing only the matching fruits
  return this.allFruits.filter((fruit: any) => {
    // Split each fruit by comma and take the first part      console.log(Content)
    // fromAirportString?.split(` `)[1]?.trim()?.split(',')[0]
    let Content:any 
if(filterValue.includes('goa')){
// let array:any=['GOI  Goa,India - Dabolim Airport','GOX  GOA,India - Manohar International Airport','GOA  Genoa,Italy - Genoa Cristoforo Colombo Airport']
// return array
Content=fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[0]+fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[1]
}else{
    if(filterValue.split('').length>3){
       Content = fruit?.split(',')[0]?.toLowerCase()?.trim()?.split(` `)[1];
    }else{
      Content = fruit.split(',')[0]?.toLowerCase()?.trim().split(` `)[0];

    }}
    const Content1 = fruit.split(',')[1].toLowerCase().trim();
// console.log(Content)
    // Check if the lowercase fruit content includes the lowercase filterValue
   // return Content.includes(filterValue)||Content1.includes(filterValue);
  //  console.log(filterValue)
  //   console.log(Content)
    
    return Content?.includes(filterValue) 

  } );
}


list:any=[
  
]


}
